<template>
    <div>
        <i class="fas fa-search pointer text-primary btn-lg" data-toggle="modal" :data-target="'#modal' + _uid"></i>

        <div :id="'modal' + _uid" class="modal fade" role="dialog">
            <div class="modal-dialog modal-xl">
                <div class="modal-content pb-1">
                    <div class="modal-header mt-3 mb-0">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th v-if="showId">{{ $t('person.gridHeaders.id') }}</th>
                                    <th>{{ $t('person.firstName') }}</th>
                                    <th>{{ $t('person.middleName') }}</th>
                                    <th>{{ $t('person.lastName') }}</th>
                                    <th>{{ $t('person.egn') }}</th>
                                    <th>{{ $t('person.gridHeaders.email') }}</th>
                                    <th>{{ $t('person.position') }}</th>
                                    <th>{{ $t('person.institution') }}</th>
                                    <th>{{ $t('person.institutionLocation') }}</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr>
                                    <td v-if="showId"></td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.firstName"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.middleName"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.lastName"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.identificationNumber"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.email"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.position"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.institution"
                                               @input="onInput">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="searchModel.institutionLocation"
                                               @input="onInput">
                                    </td>
                                </tr>
                                <tr v-if="!isEmpty && (!searching && (!resultPeople || resultPeople.length < 1))">
                                    <td colspan="8"><h5>{{ $t('searchDropdown.noResults') }}</h5></td>
                                </tr>

                                <tr v-if="searching">
                                    <td colspan="8">
                                        <div class="loader"></div>
                                    </td>
                                </tr>
                                <tr v-else
                                    class="pointer"
                                    v-for="person in resultPeople"
                                    :key="person.id"
                                    @click="onPersonSelected($event, person)">
                                    <td v-if="showId">{{ person.id }}</td>
                                    <td>{{ person.firstName }}</td>
                                    <td>{{ person.middleName }}</td>
                                    <td>{{ person.lastName }}</td>
                                    <td>{{ person.identificationNumber }}</td>
                                    <td>{{ person.email }}</td>
                                    <td>{{ person.position }}</td>
                                    <td>{{ isEnVersion ? person.institutionEn : person.institution }}</td>
                                    <td>{{ isEnVersion ? person.institutionLocationEn : person.institutionLocation }}</td>
                                </tr>
                                <div>
                                    <div class="pagerInfoMessages pl-1" v-if="peopleFoundCount > 0 && resultPeople.length < peopleFoundCount">
                                        {{ $t('person.notAllFoundRecordsDiplayed') }}
                                    </div>
                                    <div class="pagerInfo mr-1" v-if="peopleFoundCount > 0">
                                        <span class="font-bold">{{ resultPeople.length }}</span> {{ $t('of') }} <span class="font-bold">{{ peopleFoundCount }}</span> {{ $tc('records',peopleFoundCount > 1 ? 2 : 1) }}
                                    </div>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { PersonSearchType } from '../../models/enums';
    import { PersonSearchModel } from '../../models/models';
    import { mapGetters } from 'vuex';

    export default {
        components: {},
        props: {
            value: [String, Number],
            personSearchType: {
                type: Number,
                default: PersonSearchType.Person
            },
            expanded: {
                type: Boolean,
                default: false
            },
            showId: {
                type: Boolean,
                default: false
            },
            includeMergedProfiles: {
                type: Boolean,
                default: false
            },
            showModal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searching: false,
                searchModel: new PersonSearchModel({ personSearchType: this.personSearchType,
                    includeMergedProfiles: this.includeMergedProfiles }),
                resultPeople: [],
                peopleFoundCount: null
            }
        },
        mounted() {
        },
        methods: {
            onInput() {
                if (this.searchModel.firstName.length > 0 || this.searchModel.middleName.length > 0
                    || this.searchModel.lastName.length > 0 || this.searchModel.identificationNumber.length > 0 || this.searchModel.email.length > 0
                    || this.searchModel.position.length > 0 || this.searchModel.institution.length > 0 || this.searchModel.institutionLocation.length > 0) {
                    this.search(this);
                } else {
                    this.resultPeople = [];
                    this.peopleFoundCount = null;
                }
            },
            search: _.debounce(vm => {
                vm.resultPeople = [];
                vm.searching = true;

                vm.$http.post('/api/search/person', vm.searchModel).then(result => {
                    vm.resultPeople = [];
                    if (result) {
                        vm.resultPeople = result.data.people;
                        vm.peopleFoundCount = result.data.peopleFoundCount;
                    }
                }).catch(error => {

                }).then(() => (vm.searching = false));
            }, 350),
            onPersonSelected(event, selectedPerson) {
                this.$emit('onPersonSelected', selectedPerson);
                $('#modal' + this._uid).modal('hide');
            }
        },
        computed: {
            ...mapGetters(['isEnVersion']),
            isEmpty() {
                return this.searchModel.firstName.length < 1 && this.searchModel.middleName.length < 1 && this.searchModel.lastName.length < 1
                    && this.searchModel.identificationNumber.length < 1 && this.searchModel.email.length < 1 && this.searchModel.position.length < 1
                    && this.searchModel.institution.length < 1;
            }
        },
        watch: {
            showModal(newVal) {
                if (newVal === true) {
                    $('#modal' + this._uid).modal('show');
                }
            }
        }
    }
</script>

<style scoped>
    .pagerInfo {
        position: absolute;
        right: 0;
        color: rgba(0,0,0,0.54);
    }

    .pagerInfoMessages {
        color: rgba(0,0,0,0.54);
        position: absolute;
    }

    .pb-1 {
        padding-bottom: 1rem!important;
    }

    .mr-1 {
        margin-right: 24px!important;
    }

    .pl-1 {
        padding-left: 12px!important;
    }

    .font-bold {
        font-weight: bold;
    }
</style>
